export const colors = {
  borderColorLight: "#E0E0E0",
  outlinedBackground: "#EBEFFF",
  navbarFooterBtn: "#F1F3F5",
  helpOutlineBtn: "#060F16",
  toolbarBackground: "#1A237F",
  avatarBackground: "#0038FF",
};
